export default __webpack_public_path__ + "static/Case-Study-Customised-Software-Development-fb95cfdebe922591cf8afc8e769edd56.pdf";